export default __webpack_public_path__ + "static/media/summerchallenge11.0f5d94b8.jpg";